import { Box, Typography } from "@mui/material";

/** Replica `.mp-num`: círculo de 22px en el color de marca con el número de la tarjeta. */
export const BadgeNumber = ({ n }: { n: number }) => (
  <Box
    sx={{
      display: "grid",
      placeItems: "center",
      flexShrink: 0,
      width: 22,
      height: 22,
      borderRadius: "50%",
      bgcolor: "primary.main",
    }}
  >
    <Typography component="span" sx={{ fontFamily: "Outfit", fontSize: 11.5, fontWeight: 600, color: "#fff" }}>
      {n}
    </Typography>
  </Box>
);
